var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "id": "modal-search-coupon",
      "title": "選擇優惠券",
      "no-close-on-backdrop": ""
    },
    on: {
      "show": _vm.initializeTempCoupons
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn() {
        return [_c('div', {
          staticClass: "w-100 d-flex"
        }, [_c('div', {
          staticClass: "pagination mr-auto d-flex align-items-center"
        }, [_c('a', {
          staticClass: "mr-2 arrow-point",
          on: {
            "click": function click($event) {
              return _vm.navigateToPage(1);
            }
          }
        }, [_c('IconNavigateToFirst', {
          attrs: {
            "fill": _vm.meta.current_page === 1 ? '#ccc' : 'black'
          }
        })], 1), _c('a', {
          staticClass: "mr-2 arrow-point",
          on: {
            "click": function click($event) {
              return _vm.navigateToPage(_vm.meta.current_page - 1);
            }
          }
        }, [_c('IconAngleLeft', {
          attrs: {
            "fill": _vm.meta.current_page === 1 ? '#ccc' : 'black'
          }
        })], 1), _c('span', {
          staticClass: "mr-2 d-inline-block page-number",
          on: {
            "click": function click($event) {
              $event.preventDefault();
              return _vm.navigateToPage(_vm.meta.current_page);
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.meta.current_page) + " / " + _vm._s(_vm.meta.last_page) + " ")]), _c('a', {
          staticClass: "mr-2 arrow-point",
          on: {
            "click": function click($event) {
              return _vm.navigateToPage(_vm.meta.current_page + 1);
            }
          }
        }, [_c('IconAngleRight', {
          attrs: {
            "fill": _vm.meta.current_page === _vm.meta.last_page ? '#ccc' : 'black'
          }
        })], 1), _c('a', {
          staticClass: "arrow-point",
          on: {
            "click": function click($event) {
              return _vm.navigateToPage(_vm.meta.last_page);
            }
          }
        }, [_c('IconNavigateToLast', {
          attrs: {
            "fill": _vm.meta.current_page === _vm.meta.last_page ? '#ccc' : 'black'
          }
        })], 1)]), _c('b-button', {
          staticClass: "mr-2 ml-3",
          attrs: {
            "variant": "danger",
            "size": "sm"
          },
          on: {
            "click": _vm.closeModal
          }
        }, [_vm._v(" 取消 ")]), _c('b-button', {
          attrs: {
            "variant": "primary",
            "size": "sm"
          },
          on: {
            "click": _vm.submitSelectedCoupon
          }
        }, [_vm._v(" 確定 ")])], 1)];
      },
      proxy: true
    }])
  }, [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "placeholder": "請輸入優惠券名稱"
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetchCoupons(1);
      }
    },
    model: {
      value: _vm.query.keyword,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "keyword", $$v);
      },
      expression: "query.keyword"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    on: {
      "click": function click($event) {
        return _vm.fetchCoupons(1);
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])], 1)], 1), _c('div', {
    staticClass: "row mt-3"
  }, [_c('div', {
    staticClass: "col-12 d-flex align-items-center"
  }, [_c('label', {
    staticClass: "mb-0 mr-2",
    staticStyle: {
      "min-width": "80px"
    }
  }, [_vm._v("分店：")]), _c('AppSingleSelect', {
    staticClass: "flex-fill",
    attrs: {
      "options": _vm.branchOptions,
      "disabled": _vm.disableBranchSelect
    },
    on: {
      "input": _vm.branchChange
    },
    model: {
      value: _vm.selectedBranch,
      callback: function callback($$v) {
        _vm.selectedBranch = $$v;
      },
      expression: "selectedBranch"
    }
  })], 1)]), _c('div', {
    staticClass: "row mt-3"
  }, [_c('div', {
    staticClass: "col-12 d-flex align-items-center"
  }, [_c('label', {
    staticClass: "mb-0 mr-2",
    staticStyle: {
      "min-width": "80px"
    }
  }, [_vm._v("領取方式：")]), _c('b-form-select', {
    staticClass: "flex-fill",
    attrs: {
      "options": _vm.takeTypes
    },
    model: {
      value: _vm.query.take_type,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "take_type", $$v);
      },
      expression: "query.take_type"
    }
  })], 1)]), _vm.isLoading ? _c('div', {
    staticClass: "text-center mt-3 mb-3 loading-spinner"
  }, [_c('b-spinner', {
    attrs: {
      "variant": "secondary",
      "small": ""
    }
  })], 1) : _vm.coupons.length > 0 ? _c('div', {
    staticClass: "mt-3 mb-3"
  }, _vm._l(_vm.coupons, function (coupon) {
    return _c('div', {
      key: coupon.redeem_code_bundle_id,
      staticClass: "d-flex align-items-center py-2 coupon-item",
      on: {
        "click": function click($event) {
          return _vm.handleSelected(coupon);
        }
      }
    }, [[coupon.img_url ? _c('b-img-lazy', {
      staticClass: "mx-2 thumb-image flex-shrink-0",
      attrs: {
        "src": coupon.img_url,
        "alt": "優惠券圖片",
        "width": "50",
        "height": "25"
      }
    }) : _c('div', {
      staticClass: "mx-2 flex-shrink-0",
      style: {
        width: '50px',
        height: '25px'
      }
    })], _c('div', {
      staticClass: "mr-auto text-nowrap text-truncate"
    }, [_c('div', {
      staticClass: "font-weight-bold"
    }, [_vm._v(" " + _vm._s(coupon.name) + " ")]), _c('small', {
      staticClass: "text-muted"
    }, [_vm._v(" " + _vm._s(_vm.format(new Date(coupon.start_at), 'yyyy-MM-dd HH:mm')) + " ~ " + _vm._s(_vm.format(new Date(coupon.end_at), 'yyyy-MM-dd HH:mm')) + " ")])]), _c('div', {
      staticClass: "mx-2"
    }, [_vm.selectedCouponIds.includes(coupon.id) ? _c('span', {
      staticClass: "mdi mdi-check-circle mdi-24px"
    }) : _vm._e()])], 2);
  }), 0) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }